import { gql } from '@apollo/client';

export const DELETE_POST = gql`
  mutation DeletePost($input: DeletePostInput!) {
    deletePost(input: $input) {
      success
      errors
    }
  }
`;
